export default __webpack_public_path__ + "assets/estonia-flag.png";